import { motion } from "framer-motion";
import { FadeUp } from "./Reveal";
import { GRAPHIC_CATS, LOGOS } from "../data/content";
import { useLang } from "../lib/lang";
import { scrollToId } from "../lib/smooth";

export const CatNav = () => {
  const { tr } = useLang();
  return (
    <div data-testid="graphic-cat-nav" className="flex flex-wrap gap-2">
      {GRAPHIC_CATS.map((c) => (
        <button key={c.id} data-testid={`graphic-cat-btn-${c.id}`} onClick={() => scrollToId(`cat-${c.id}`)} className="rounded-full border border-white/15 px-4 py-2 text-sm text-zinc-300 transition-colors hover:border-[var(--acid)] hover:bg-[var(--acid)] hover:text-[var(--ink)]">
          <span className="mr-2 font-mono text-[11px] opacity-70">{c.n}</span>{tr(c.title)}
        </button>
      ))}
    </div>
  );
};

export const LogoWall = () => {
  const { tr } = useLang();
  return (
    <div data-testid="logo-wall">
      <FadeUp className="mb-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{tr({ es: "Logofolio — marcas que he dise\u00f1ado", en: "Logofolio — brands I've designed" })}</FadeUp>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {["mock_sirius", "mock_austin"].map((m) => (
          <FadeUp key={m} className="group col-span-2 overflow-hidden rounded-2xl sm:col-span-3">
            <img src={`/work/gd/${m}.jpg`} alt="Brand mockup" loading="lazy" className="aspect-[3/2] w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
          </FadeUp>
        ))}
        {LOGOS.map((l, i) => (
          <motion.div
            key={l}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: (i % 6) * 0.05 }}
            whileHover={{ y: -6, rotate: -1.5 }}
            className="grid aspect-square place-items-center rounded-2xl bg-white p-5 transition-shadow hover:shadow-[0_20px_40px_-12px_rgba(242,138,192,0.5)]"
          >
            <img src={`/work/gd/${l}.png`} alt="logo" loading="lazy" className="max-h-full max-w-full object-contain" />
          </motion.div>
        ))}
      </div>
    </div>
  );
};
